export const isNewerVersion = (latestVersion: string, compareVersion: string): boolean => {
    const latestParts = latestVersion.split('.')
    const compareParts = compareVersion.split('.')

    for (let i = 0; i < latestParts.length; i += 1) {
        const latestPart = ~~latestParts[i]
        const comparePart = ~~compareParts[i]

        if (latestPart > comparePart) return true
        if (latestPart < comparePart) return false
    }

    return false
}

export const clearCaches = async (): Promise<void> => {
    if ('caches' in window) {
        const names = await caches.keys()

        // Wait for the deletion, so the reload doesn't load the old files from a cache that still exists
        await Promise.all(names.map(name => caches.delete(name)))
    }

    window.location.reload()
}
